import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { LanguageService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-language-toggle',
  templateUrl: './language-toggle.component.html',
})
export class LanguageToggleComponent implements OnInit {
  selectedLanguage: string;
  @Output()
  outputLanguage = new EventEmitter();

  constructor(private languageService: LanguageService) {}

  ngOnInit() {
    this.selectedLanguage = this.languageService.getSelectedLanguage();
    if (this.selectedLanguage === 'fr' || this.selectedLanguage === 'en') {
      this.outputLanguage.emit('FR');
    } else {
      this.outputLanguage.emit('NL');
    }
  }

  toggle(event) {
    if (this.selectedLanguage === 'en' || this.selectedLanguage === 'fr') {
      this.outputLanguage.emit(event.target.checked ? '' : 'FR');
    } else {
      this.outputLanguage.emit(event.target.checked ? '' : 'NL');
    }
  }
}
